module.exports = __webpack_public_path__ + "img/dot_outlined.174f2548.svg";